import Vue from 'vue'

export default Vue.extend({
  methods: {
    withNewlines(value: any): string {
      return (value || '')
        .toString()
        .split('\n')
        .join('<br />')
    },
    isEmpty(field: string | number | null | undefined) {
      if (field === null || field === undefined) {
        return true
      } else if (
        typeof field === 'string' &&
        (field.length === 0 || field === '1.\n2.\n3.' || /^\s*$/.test(field))
      ) {
        return true
      } else {
        return !field
      }
    },
  },
  props: {
    editable: {
      default: false,
      type: Boolean,
    },
    value: {
      required: true,
      type: Object,
    },
  },
})
